module.exports = __webpack_public_path__ + "static/media/activo.4f542932.png";